/**
 * Enum representing server-side error codes.
 *
 * These error codes are returned by the server API to indicate specific
 * issues encountered during request processing. Each code is associated with
 * a unique string identifier.
 *
 * @enum {string}
 */
export enum ServerError {
    /**
     * Error code indicating that the requested user was not found.
     *
     * Returned when an operation attempts to access a user that does not exist.
     *
     * @type {string}
     */
    USER_NOT_FOUND = "U02",

    /**
     * Error code indicating that the provided user credentials (e.g., password)
     * are invalid.
     *
     * Returned during login or authentication failures due to incorrect credentials.
     *
     * @type {string}
     */
    INVALID_CREDENTIALS = "I02",

    /**
     * Error code indicating that the user must change their password.
     *
     * Returned when the server requires a password reset or change for security reasons.
     *
     * @type {string}
     */
    CHANGE_PASSWORD = "PW01",
}
